<script>
import {mapState} from 'vuex'

export default {
    computed: {
        ...mapState({
            userRoles: state => state.user.profile.roles
        })
    },
    methods: {
        hasRole(role) {
            let valid = false
            if (!role || !this.userRoles) {
                return valid
            } else {
                if (typeof role === 'string') {
                    valid = this.userRoles.includes(role)
                } else if (Array.isArray(role)) {
                    role.map(item => {
                        if (this.userRoles.includes(item)) {
                            valid = true
                        }
                    })
                }
            }
            return !!(valid)
        },
        isAdmin() {
            return this.hasRole('admin')
        },
        canEdit(permission) {
            if (this.isAdmin()) {
                return true
            }
            if (permission) {
                return this.$lodash.intersection(
                    Array.isArray(permission) ? permission : [permission],
                    [
                        this.$const.campaign.permission.ADMIN,
                        this.$const.campaign.permission.OWNER,
                        this.$const.campaign.permission.OUTBOUND_CALLER
                    ]
                ).length > 0
            }
            return false
        },
        canExportReport(permission) {
            if (permission) {
                return ['admin', 'owner', 'outbound_caller', 'reporter'].includes(permission[0])
            }
            return false
        },
        canAssignRoles(permission) {
            if (permission) {
                return ['admin', 'owner'].includes(permission[0])
            }
            return false
        },
        isOwnerOrAdmin(permission) {
            if (this.isAdmin()) {
                return true
            }
            if (permission) {
                return this.$lodash.intersection(
                    Array.isArray(permission) ? permission : [permission],
                    [
                        this.$const.campaign.permission.ADMIN,
                        this.$const.campaign.permission.OWNER
                    ]
                ).length > 0
            }
            return false
        },
        canEditQCCampaign(permission) {
            return ['admin', 'qc_lead'].includes(permission)
        },
        isAdminQCCampaign(permission) {
            return permission === 'admin'
        },
    }
}
</script>
